import type { ShippingSchemaType } from '@/components/steps/ShippingAddressStep/ShippingAddressStep';
import { ADDRESS_TYPE } from '@/components/steps/ShippingAddressStep/shippingSchema';
import SummaryStepSection from '@/components/steps/SummaryStep/SummaryStepSection';
import { FeatureToggles } from '@/configuration/featureToggle/featureToggles';
import { useCountryNames } from '@/hooks/useCountryNames';
import { useFeatureToggle } from '@/hooks/useFeatureToggle';
import { addressBuilder, t } from '@/lib/utils';

export type SummaryStepShippingSectionProps = {
    goToPage: (stepNumber: number) => void;
    shippingAddressState: ShippingSchemaType;
    className?: string;
    isOrderNewCard: boolean;
};

export const SummaryStepShippingSection = ({
    shippingAddressState,
    goToPage,
    className,
    isOrderNewCard,
}: SummaryStepShippingSectionProps) => {
    const shippingCountryWithFlag = useCountryNames()?.find(item => item.id === shippingAddressState.country)?.label;
    const goToPageIndex = isOrderNewCard ? 1 : 2;
    const { value: redesignToggleValue } = useFeatureToggle(FeatureToggles.SHIPPING_ADDRESS_REDESIGN);
    const isRedesignEnabled = Boolean(redesignToggleValue);
    const isCompanyType = shippingAddressState.addressType === ADDRESS_TYPE.company;

    return (
        <SummaryStepSection
            title={t('onboarding.shippingAddress.title')}
            className={className}
            goToFunction={() => goToPage(goToPageIndex)}
        >
            {isRedesignEnabled && isCompanyType && shippingAddressState.companyName && (
                <div className='padding-bottom-5'>
                    {`${t('general.companyName')}: `}
                    <strong>{shippingAddressState.companyName}</strong>
                </div>
            )}
            {shippingAddressState.addressee && (
                <div className='padding-bottom-5'>
                    <div>
                        {`${t(isRedesignEnabled ? 'general.recipient' : 'general.addressee')}: `}
                        <strong>{shippingAddressState.addressee}</strong>
                    </div>
                </div>
            )}
            <div className='padding-bottom-5'>
                {`${t('general.address')}: `}
                <strong>
                    {addressBuilder(
                        `${shippingAddressState.address} ${shippingAddressState.address2}`.trim(),
                        shippingAddressState.postCode,
                        shippingAddressState.city,
                        shippingCountryWithFlag ?? ''
                    )}
                </strong>
            </div>
        </SummaryStepSection>
    );
};
